import { Asset } from 'types/Attachments';

export function pickAssetThumbnail(asset: Asset): string | null {
  if (asset.type === 'video' && asset.poster_url) return asset.poster_url;
  if (asset.thumbnail_url) return asset.thumbnail_url;
  if (asset.url && asset.type === 'image') return asset.url;
  return null;
}
